<template>
    <el-form-item label="Merchant ID" prop="merchantId">
        <template v-slot:label>
            <span>Merchant ID
            <el-tooltip popper-class="tips_content" effect="light" :content="txt" placement="right">
                <div slot="content" v-html="txt">{{txt}}</div>
                <img class="tips" src="@/assets/pc/Surface-Tooltip.svg" align="middle" />
            </el-tooltip>
            </span>
        </template>
        <el-input v-model="inputValue"  placeholder="Merchant ID" maxlength="32" clearable></el-input>
    </el-form-item>
</template>
<script>
export default {
    name: 'BdoMerchantId',
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
    },
    data() {
        return {
            inputValue: '',
            txt: '<span style="color:#0271D8">The merchant ID must be 10 <br/>characters long. <br/><br/>You should receive this ID in your<br/> email within seven (7) business <br/>days upon signing up.</span>'
        }
    },
    watch: {
        value(newValue) {
            this.inputValue = newValue
        },
        inputValue(newValue) {
            this.$emit("input", newValue)
        }
    }
}
</script>
<style lang="scss" scoped>
.tips {
    vertical-align: middle;
    margin-bottom: 3px;
}
</style>
<style lang="scss">
.tips_content {
    box-shadow: 0px 0px 16px #00000014;
    border-radius: 8px !important;
    border: 0 !important;
    .popper__arrow {
        box-shadow: 0px 0px 16px #00000014;
        border: 0 !important;
    }
}
</style>